import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { CoreSaveService, ConfigService, UtilsService, MessageService, ICommonMessage, FieldType } from '@gbs-platform-client/fwk-core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs'; 
import { AddUser, UserRole, Emp } from '../../models/adduser';
import { AddUserService } from '../../services/adduser.service'; 
import { RoleMaster } from '../../models/rolemaster';
import { RoleMasterService } from '../../services/role'; 
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { UserType } from '../../models/adduser';
import { Alert } from 'selenium-webdriver'; 
@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {
  @ViewChild('typeApproval') typeApproval!: TemplateRef<any>;
  @ViewChild('approvalId') approvalId!: TemplateRef<any>;
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('approved') approved!: TemplateRef<any>;
  @Output() closeAddUser = new EventEmitter<null>();
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerAddUser: PageHeader;
  entity: AddUser = new AddUser();
  saveentity: AddUser = new AddUser();
  editingEntity: AddUser = new AddUser();
  selectedBranchcategory: AddUser = new AddUser(); 
  emplo: Array<Emp> ;
  role: Array<RoleMaster>;
  type: Array<UserType> ;
  adduser: Array<AddUser>;
  adduserColumns: any[];
  listView: boolean = true;
  formCaption: string = '';
  selectentity: any;
  selectemp: any;
  selectrole: any;
  selectvendor: any; 
  emailcheck: boolean = true; 
  entityColumns: any[] = [];
  defaultRowsCount: number;
  addUserMaster: boolean = false;
  saveDisabled: boolean = false;
  showBranch: boolean = false;
  disableSave: boolean = true;
  valid = 0;
  letterCheck:boolean=true;
  letterupCheck:boolean=true;
  specialCheck:boolean=true;
  numCheck:boolean=true;
  constructor(
    private _adduserService: AddUserService,
    private configService: ConfigService, 
    private _RoleMasterService: RoleMasterService, 
    private _coreSaveService: CoreSaveService,
    private messageService: MessageService,
    private notification: NotificationsService,) {

    this.headerAddUser = this.initPageHeader();
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.adduserColumns = [
      { field: "UserId", title: 'User Id', filter: true, sortable: true },
      { field: "UserName", title: 'User Name', filter: true, sortable: true },
      { field: "DisplayName", title: 'Display Name', filter: true, sortable: true },
      { field: "Role_Name", title: 'Role Name', filter: true, sortable: true },
      { field: "Emp_Name", title: 'Employee Name', filter: true, sortable: true },
      { field: "Entity_Name", title: 'Entity Name', filter: true, sortable: true },
      { field: "Email", title: 'Email Id', filter: true, sortable: true },
      { field: "PhoneNumber", title: 'Phone', filter: true, sortable: true }
    ];

    this.adduser = []; 
    this.role = [];
    this.type = [];
    this.entity.UserRoles.push(new UserRole());
    this.selectrole = { User_Type_Name: "EMPLOYEE", UserTypeId: 1 };
    this.getAllAdduser();
    this.getAllRoles();
    this.emplo = [];
    const user = JSON.parse(localStorage.getItem('currentUser') || '{}');  
    if (Object.keys(user).length > 0) {
      this.addUserMaster = true;
    }
    else {
      this.addUserMaster = false;
    } 
    if (this.addUserMaster === false) { 
      this.getusertype();  
    }
  }
  checkValidPassword(): boolean {
    this.valid = 0;
    var special =/[!"£$%^&*()-_=+]/;
     var letter = /[a-z]/;
    var letterUp = /[A-Z]/;
    var number = /[0-9]/;

    const password = this.entity.PasswordHash;
    if (password.length < 6 || !letter.test(password) || !letterUp.test(password) || !number.test(password) || !special.test(password)) {
      if (password.length < 6) {
        this.notification.showWarning("Please make sure password is longer than 6 characters.");
        this.valid++;
        return false;
      }
      else if (!letter.test(password) || !letterUp.test(password)) {
        this.notification.showWarning("Please make sure Password Includes an UpperCase and LowerCase character");
        this.valid++;
        return false;
      }
      else if(!special.test(password)){
        this.notification.showWarning("Please make sure that password includes special character");
        return false;
      }
      else if (!number.test(password)) {
        this.notification.showWarning("Please make sure Password Includes a Digit");
        this.valid++;
        return false;
      }
    }
    else {
      this.disableSave = false; 
    } 
    return true;
  }

  ngAfterViewInit(): void {
    this.entityColumns = [
      { field: "Text_Value", title: 'Role', template: this.typeApproval },
      { field: "Action", title: 'Action', template: this.approved },
    ];  
  }

  getAllAdduser() {
    this._adduserService.getAllAdduser().subscribe((adduser: Array<AddUser>) => {
      this.adduser = adduser;
    });
  }
   
  getusertype() {
    this._adduserService.getusertype().subscribe((type: Array<UserType>) => {
      this.type = type;
    });
  }
  getAllRoles() {
    this._RoleMasterService.getAllRoles().subscribe((role: Array<RoleMaster>) => {
      this.role = role;
    });
  }
  ngOnInit(): void { 
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._adduserService.deleteUser(this.selectedBranchcategory.UserId).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearuser();
            this.getAllAdduser();
          },
          )
        }
      }
    });
  }

  initPageHeader(): PageHeader {
    let headerAddUser = new PageHeader();
    headerAddUser.PageCaption = "Add User";
    headerAddUser.IconClass = "bi bi-bank";
    return headerAddUser;
  }

  deleteuser(event: any) {
    if (event.seletedRows[0]) {
      this.selectedBranchcategory.UserId = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Delete User",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addUser(event: any) {
    this.listView = false;
    this.formCaption = "Add User"; 
    this.getusertype(); 
    this.getAllRoles();
  }
  onempChanged(event: any) {
    
  }
  edituser(event: any): void {
    if (event.seletedRows[0]) {
      this._adduserService.viewUser(event.seletedRows[0]).subscribe((adduser: Array<AddUser>) => {
        let editbranchcategory = adduser[0] ? adduser[0] : new AddUser()
        if (editbranchcategory) {
          this.editingEntity = editbranchcategory;
          this.entity = { ...this.editingEntity }
          this.selectentity = { Entity_Name: editbranchcategory.Entity_Name, CompanyId: editbranchcategory.Entity_Id };
          this.selectemp = { Emp_Name: editbranchcategory.Emp_Name, EmpRefId: editbranchcategory.EmpRefId };
          this.selectrole = { User_Type_Name: editbranchcategory.User_Type_Name, UserTypeId: editbranchcategory.UserTypeId };
          this.selectvendor = { Vendor_Name: editbranchcategory.Vendor_Name, Vendor_Id: editbranchcategory.Vendor_Id };
          this.listView = false;
          this.formCaption = "Edit User";
          this.entity.EntityMetaData = [
            { FieldName: 'UserName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'User Name is required' },
            { FieldName: 'EmpRefId', FieldType: FieldType.Key, IsMandatory: true, ValidationMessage: 'Name is required' },
            { FieldName: 'Entity_Id', FieldType: FieldType.Key, IsMandatory: true, ValidationMessage: 'Entity Name is required' },
            { FieldName: 'Email', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Email Id is required' },
            { FieldName: 'PasswordHash', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Password is required' },
            { FieldName: 'PhoneNumber', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Phone is required' },
            { FieldName: 'User_Type_Name', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'User Type is required' },
          ];
          this.getAllAdduser(); 
          this.getusertype();
          this.getAllRoles(); 
        }
      }); 
    }
  }

  save(event: any): void { 
    this.saveDisabled = true;
      if (this.entity.UserName == "" || this.entity.UserName === undefined) {
        this.notification.showWarning('Please enter User Name');
        this.saveDisabled = false;
        return;
      }
      if (this.entity.PasswordHash == "" || this.entity.PasswordHash === undefined) {
        this.notification.showWarning('Please enter Password');
        this.saveDisabled = false;
        return;
      }
      if (this.entity.CompanyId == 0 || this.entity.CompanyId === undefined) {
        this.notification.showWarning('Please select entity');
        this.saveDisabled = false;
        return;
      }
      if (this.entity.UserTypeId == 0 || this.entity.UserTypeId === undefined) {
        this.notification.showWarning('Please select user type');
        return;
      }
      if (this.entity.UserTypeId === 1) {
        if (this.entity.EmpRefId == 0 || this.entity.EmpRefId === undefined) {
          this.notification.showWarning('Please select employee');
          this.saveDisabled = false;
          return;
        }
      }
      if (this.entity.UserTypeId === 2) {
        if (this.entity.EmpRefId == 0 || this.entity.EmpRefId === undefined) {
          this.notification.showWarning('Please select vendor');
          this.saveDisabled = false;
          return;
        }
      }
      if (this.entity.Email == "" || this.entity.Email === undefined) {
        this.notification.showWarning('Please enter email');
        this.saveDisabled = false;
        return;
      }
      if (this.entity.PhoneNumber == "" || this.entity.PhoneNumber === undefined) {
        this.notification.showWarning('Please enter phone number');
        this.saveDisabled = false;
        return;
      }
      if (this.entity.Role_Id == "" || this.entity.Role_Id === undefined) {
        this.notification.showWarning('Please enter atleast one role');
        this.saveDisabled = false;
        return;
      }

      this._adduserService.checkDuplication(this.entity.UserName, this.entity.UserId).subscribe((res) => {
        if (res.Data.length > 0) {
          this.notification.showWarning('User already exists');
          this.saveDisabled = false;

        }
        else {
          const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          this.emailcheck = re.test(String(this.entity.Email).toLowerCase());
          if (this.emailcheck === false){
            this.notification.showWarning("Email not valid");
            this.saveDisabled = false;
          }
          else {
            this._adduserService.checkEmail(this.entity.Email, this.entity.UserId).subscribe((response) => {
              if (response.Data.length > 0) {
                this.notification.showWarning("Email already exists");
                this.saveDisabled = false;
              }
              if (this.entity.PhoneNumber.length != 10) {
                this.notification.showWarning("Invalid phone No.");
                this.saveDisabled = false;
                return;
               
              }
             const special =/[!"£$%^&*()-_=+]/;
              const letter = /[a-z]/;
              const letterUp = /[A-Z]/;
              const number = /[0-9]/;
             const password = this.entity.PasswordHash;
            
             this.letterCheck = (letter.test(String(this.entity.PasswordHash).toString())&&(letterUp.test(String(this.entity.PasswordHash).toString()))&&(special.test(String(this.entity.PasswordHash).toString()))&&(number.test(String(this.entity.PasswordHash).toString())));
             
             if (this.letterCheck == false) {
               this.notification.showWarning("Invalid Password");
               return;
             }
              else {
                this._adduserService.saveUser(this.entity).subscribe(() => {

                  if (this.entity.UserId == 0) {
                    this.notification.showSuccess('Saved Successfully');
                    this.closeAddUser.emit();
                  }
                  else {
                    this.notification.showSuccess('Updated Successfully');
                  }
                  if (this.addUserMaster === true) {
                    this.listView = true;
                    this.getAllAdduser();
                  }
                  this.clearuser();
                });
              }
            });
          }
        }
      }); 
  }

  gotoBack(): void {
    this.listView = true;
    this.getAllAdduser();
    this.clearuser();
  }
  refreshuser(event: any): void {
    this.adduser =[];
    this.getAllAdduser();
  }
  clearuser(): void {
    this.entity = new AddUser();
    this.saveDisabled = false;
  }
  revertChanges(): void {
    //  this.entity = { ...this.editingEntity };
  }
  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  onExcelExport() {
    this.excelexport.save()
  }
  goNext(rowIndex: number) {
    let approvalLevels = [...this.entity.UserRoles]
    approvalLevels.push(new UserRole)
    this.entity.UserRoles = approvalLevels;

  }

  goPrevious(rowIndex: number) {
    let approvalLevels = [...this.entity.UserRoles]
    if (rowIndex == 0) {
      this.notification.showWarning('Approval Mode must have atleast one entry')
    }
    else {
      approvalLevels.splice(rowIndex, 1);
      this.entity.UserRoles = approvalLevels;
    }

  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
